import React from 'react';
import PageTitle from '../../utils/PageTitle';

function DocumentationPage() {
    // set page title
    PageTitle(`Documentation`);

    return <div>DocumentationPage</div>;
}

export default DocumentationPage;
